import posthog from 'posthog-js';

const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

let initialized = false;

const canTrack = () => typeof window !== 'undefined' && !!POSTHOG_KEY;

function getSessionId() {
  const key = 'km_session_id';
  try {
    const existing = window.localStorage.getItem(key);
    if (existing) return existing;

    const next =
      typeof window.crypto?.randomUUID === 'function'
        ? window.crypto.randomUUID()
        : `km-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

    window.localStorage.setItem(key, next);
    return next;
  } catch {
    return 'km-session-unavailable';
  }
}

/**
 * Coerce to a finite integer for PostHog numeric filters (e.g. latency_ms > 500).
 * Returns undefined when missing or not coercible — omit the property instead of null.
 */
export function analyticsNumber(value) {
  if (value == null || value === '') return undefined;
  const n = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(n)) return undefined;
  return Math.round(n);
}

export function initAnalytics() {
  if (initialized || !canTrack()) return;
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    autocapture: false,
    capture_pageview: false,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',
    loaded: () => {
      initialized = true;
    },
  });
}

export function trackEvent(name, properties = {}) {
  if (!canTrack()) return;
  if (!initialized) initAnalytics();
  posthog.capture(name, {
    ...properties,
    session_id: getSessionId(),
  });
}

